export default url => {
    if (url && typeof url === 'string') {
        const matchedName = url.match(new RegExp(/http(|s):\/\/(www\.|)([a-z1-9-]+)(\.).*/, 'i'));
        if (matchedName?.[3]) {
            const name = matchedName[3];
            if (name?.length) {
                return name[0].toUpperCase() + name.substring(1);
            }
        }
    }

    return '';
};